import store from "../redux/store";

export const SUPER_ADMIN = "Super Admin";
export const ADMIN = "Admin";
export const USER = "User";

export const isCurrentUserAdmin = () => {
  const { role } = store.getState().user.user;
  return role === ADMIN || role === SUPER_ADMIN;
};

export const isCurrentUserSuperAdmin = () => {
  const { role } = store.getState().user.user;
  return role === SUPER_ADMIN;
};

export const getAvaliableUserRoles = () => {
  const userRoles = [
    { value: USER, label: "User" },
    { value: ADMIN, label: "Admin" }
  ];
  if (isCurrentUserSuperAdmin())
    userRoles.push({ value: SUPER_ADMIN, label: "Super Admin" });
  return userRoles;
};

export const canBeEdited = (organizationRef = "", globalAccess = false) => {
  if (isCurrentUserSuperAdmin()) return true;
  if (!globalAccess && organizationRef.id === store.getState().user.user.organizationRef.id)
    return true;
  return false;
};
